import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFooterComponent, FirstResponderPersonalInfoViewModel, VerificationService } from '@sheerid/jslib';
import { LogoHeaderComponent } from './LogoHeaderComponent';

const defaultSubtitle = `SheerID is reviewing your documents, to confirm your
                        status. This process may take up to 20 minutes.
                        Wait here or let us notify you of the outcome. `;

const defaultSubtitle2 = 'You will be contacted via email address.';

interface StepPendingProps {
    verificationService: VerificationService;
}

const StepPendingComponent = ({ verificationService }: StepPendingProps) => {
    const programId = verificationService.programId;
    const previousViewModel = (verificationService.previousViewModel as FirstResponderPersonalInfoViewModel) || undefined;
    const previousVerificationResponse = verificationService.previousVerificationResponse || undefined;
    const verificationId = verificationService.verificationResponse.verificationId;

    const pollForVerificationServiceUpdates = () => {
        setTimeout(
            () => {
                verificationService.fetchExistingVerificationRequest(programId, verificationId, previousVerificationResponse, previousViewModel);
            },
            20000,
        );
    };

    pollForVerificationServiceUpdates();

    return (
        <div id="sid-step-pending" className="sid-l-container">
            <div className="sid-header">
                <LogoHeaderComponent/>
                <div className="sid-header__title sid-l-space-top-lg">
                    <FormattedHTMLMessage id="step.pending.title" defaultMessage="Upload Success" />
                </div>
                <div className="sid-header__subtitle-two sid-h-small-text sid-l-space-top-md">
                    <p>Your document has uploaded successfully. The review process has now started. You will be contacted via the email address entered on the verification form in less than 20 minutes with details regarding your verification request.</p>
                    <p>NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message.</p>
                </div>
            </div>

            <div className="sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};

export { StepPendingComponent };
